// extracted by mini-css-extract-plugin
export default {"Fallback":"FullscreenDialog_Fallback__ZxEfY"};